import { Button, IEvent } from '../../../../../../component';
import nls from '../../../nls/pt-BR.json';

interface Props {
  callback: (event?: React.MouseEvent<HTMLElement>) => void;
}

export const SkipStepButton: React.FC<Props> = ({ callback }) => {
  return (
    <Button
      className="link normal"
      style={{
        textDecoration: 'underline',
        color: '#793EAD',
        fontFamily: 'Quicksand, sans-serif',
        fontSize: 14,
        fontWeight: 700,
      }}
      cy="SkipStep"
      onClick={callback}
    >
      {nls.studyCreationGuide.buttons.skipStep}
    </Button>
  );
};
